module.exports = __webpack_public_path__ + "ffe70d869749e2adef4bd5fcf30f7d3a.png";